import React, { useEffect, useState } from "react";
import moment from "moment";

import TableContainer from "@material-ui/core/TableContainer";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Checkbox from "@material-ui/core/Checkbox";
import TableRow from "@material-ui/core/TableRow";
import Person from "@material-ui/icons/Person";
import Table from "@material-ui/core/Table";
import Box from "@material-ui/core/Box";

import NewFiltersBox from "views/FilterBox/NewFiltersBox";
import Button from "components/CustomButtons/Button.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import Loader from "components/Loader/Loader.js";
import Card from "components/Card/Card.js";

import { downloadBlobFile, arrayToCsvFormat } from "common/helpers";
import { fetchRequest } from "common/service";
import { API_BASE_URL } from 'common/constants';

const useStyles = makeStyles((theme) => ({
  cellCheckbox: {padding: '8px', textAlign: 'center'},
  headerCheckbox: {padding: '8px'},
  container: {overflowX: 'auto'},
  table: {minWidth: 800}
}));

const DeviceManagement = () => {
  const classes = useStyles();

  const [originalData, setOriginalData] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [featureData, setFeatureData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const [headerStates, setHeaderStates] = useState({
    GalenBulkUploads: false,
    GalenConfAccess: false,
  });

  const fetchData = async (fetchedUserInfo = null) => {
    if(fetchedUserInfo && Object.keys(fetchedUserInfo).length > 0) {
      setUserInfo(fetchedUserInfo);
    }

    console.log(fetchedUserInfo, "fetchData", userInfo);
    if(fetchedUserInfo?.user) {
      try {
        setIsLoading(true);
        /* Identity Table data */
        const endPoint = `${API_BASE_URL}/data/devicedata-advanced/owner?pageNumber=0&pageSize=500&sortBy=maxValueProvidedOn&sortOrder=DESC`;
        
        const payload = {
          "deviceDataModelId": "d36a4373-fbdc-44a3-8c96-4bb920041e40-id",
          "devicePropertyCodes": [ "FriendlyName", "Devid", "GalenBulkUploads", "GalenConfAccess", "ForceFw"],
          "dataTypes": [ "Text", "Text", "Text", "Text", "Text"],
          "devicePropertySetId": "fdab73ae-28df-45f5-92c5-b24460daf682",
          "ownerFilter": {"users": [fetchedUserInfo?.user]}
        };

        if(fetchedUserInfo?.FriendlyName && fetchedUserInfo?.FriendlyName !== "all") {
          payload.deviceCriteria = [{"key": "Devid", "operator": "Equal", "value": fetchedUserInfo?.FriendlyName, "valueFrom": "", "valueTo": "", "isDateValue": false, "dateTimeRangeValue": null}];
        }
        
        const identityData = await fetchRequest("POST", endPoint, payload);

        /* Device Health data */
        const deviceHealthEndPoint = `${API_BASE_URL}/data/devicedata/aggregate-advanced`;
        const rangeEndDateTime = moment().utc().format("YYYY-MM-DDTHH:mm:ss");
        const deviceHealthPayload = {
          "deviceDataModelId": "d36a4373-fbdc-44a3-8c96-4bb920041e40-dh",
          "aggregationPropertyOptions": [{ "propertyCode": "Fwvers", "aggregationType": "Last" },{ "propertyCode": "DevidDevhealth", "aggregationType": "First"}],
          "deviceCriteriaGroup": { "isOr": false, "groupOwner": null, "groupElements": [
              { "isOr": false, "groupOwner": null, "groupElements": [
                  { "key": "TimestampD", "operator": "Between", valueFrom: moment(rangeEndDateTime).subtract(1, "year").format("YYYY-MM-DDTHH:mm:ss"), valueTo: rangeEndDateTime}
                ]
              }
            ]
          },
          "groupingPropertyOptions": [{"propertyCode": "DevidDevhealth"}],
          "firstOrLastAggregationTypeSortBy": "TimestampD",
          "ownerFilter": {"users": [fetchedUserInfo?.user]}
        };
        if(fetchedUserInfo?.FriendlyName && fetchedUserInfo?.FriendlyName !== "all") {
          deviceHealthPayload.deviceCriteriaGroup.groupElements[0].groupElements.push({"key": "DevidDevhealth", "operator" : "Equal", "value" : fetchedUserInfo?.FriendlyName});
        }
        
        const deviceHealthData = await fetchRequest("POST", deviceHealthEndPoint, deviceHealthPayload);

        const _featureData = identityData?.content?.map(identityItem => {
          const matchingParams = deviceHealthData?.content?.find(deviceHealthItem => 
            deviceHealthItem?.data?.DevidDevhealth?.value === identityItem?.data?.Devid?.value
          );
          
          return {
            ...identityItem,
            data: {
              ...identityItem?.data,
              GalenBulkUploads: identityItem?.data?.GalenBulkUploads,
              GalenConfAccess: identityItem?.data?.GalenConfAccess,
              paramsDeviceDataId: matchingParams?.deviceDataId,
              Fwvers: matchingParams?.data?.["Last-Fwvers"] || identityItem?.data?.ForceFw || matchingParams?.data?.Fwvers,
            }
          };
        }).filter(item => item !== null) || [];

        setFeatureData(_featureData);
        setOriginalData(JSON.parse(JSON.stringify(_featureData))); // Deep copy for comparison
        setIsLoading(false);
      } catch (error) {
        console.error('Error in getLastPVitalsForSensor:', error);
        setIsLoading(false);
      }
    } 
  }

  // Handle individual checkbox changes
  const handleCheckboxChange = (rowIndex, field, checked) => {
    const updatedData = [...featureData];
    const updatedValue = checked ? 'Yes' : 'No';

    if(updatedData[rowIndex].data[field] && updatedData[rowIndex].data[field].value) {
      updatedData[rowIndex].data[field].value = updatedValue;
    } else {
      updatedData[rowIndex].data[field] = {
        valueProvidedOn: new Date().toISOString(),
        value: updatedValue,
        reference: null,
        link: null
      }
    }
    setFeatureData(updatedData);
    
    const hasAnyChanges = updatedData.some((item, index) => {
      const original = originalData[index];
      return original && (
        item.data.GalenBulkUploads?.value !== original.data.GalenBulkUploads?.value ||
        item.data.GalenConfAccess?.value !== original.data.GalenConfAccess?.value
      );
    });
    setHasChanges(hasAnyChanges);
  };

  // Handle header checkbox changes
  const handleHeaderCheckboxChange = (field, checked) => {
    const updatedData = featureData.map(item => ({
      ...item,
      data: {
        ...item.data,
        [field]: {
          ...item.data[field],
          value: checked ? 'Yes' : 'No'
        }
      }
    }));
    
    setFeatureData(updatedData);
    
    // Update header states
    setHeaderStates(prev => ({ 
      ...prev, 
      [field]: checked
    }));
    
    // Check if there are changes
    const hasAnyChanges = updatedData.some((item, index) => {
      const original = originalData[index];
      return original && (
        item.data.GalenConfAccess?.value !== original.data.GalenConfAccess?.value ||
        item.data.GalenBulkUploads?.value !== original.data.GalenBulkUploads?.value
      );
    });
    setHasChanges(hasAnyChanges);
  };

  // Update header states based on current data
  useEffect(() => {
    if (featureData.length > 0) {
      const allBulkUploadsChecked = featureData.every(item => 
        item.data?.GalenBulkUploads?.value === 'yes' || item.data?.GalenBulkUploads?.value === 'Yes'
      );
      const allConfAccessChecked = featureData.every(item => 
        item.data?.GalenConfAccess?.value === 'yes' || item.data?.GalenConfAccess?.value === 'Yes'
      );
      
      setHeaderStates({
        GalenBulkUploads: allBulkUploadsChecked,
        GalenConfAccess: allConfAccessChecked,
      });
    }
  }, [featureData]);

  // Download CSV data
  const downloadCSVData = () => {
    if (featureData.length === 0) {
      alert("No data found");
      return;
    }

    const headers = [
      "User",
      "FriendlyName", 
      "DevID",
      "Fwvers",
      "GalenBulkUploads",
      "GalenConfAccess"
    ];

    const values = featureData.map(item => ({
      User: userInfo?.fullName || 'N/A',
      FriendlyName: item?.data?.FriendlyName?.value || 'N/A',
      DevID: item?.data?.Devid?.value || 'N/A',
      Fwvers: item?.data?.Fwvers?.value || 'N/A',
      GalenBulkUploads: item?.data?.GalenBulkUploads?.value || 'N/A',
      GalenConfAccess: item?.data?.GalenConfAccess?.value || 'N/A'
    }));

    downloadBlobFile(
      arrayToCsvFormat(values, headers), 
      `premium_features_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`, 
      "text/csv;charset=utf-8;"
    );
  };

  // Handle save button click
  const handleSave = async() => {
    const changedData = featureData.filter((item, index) => {
      const original = originalData[index];
      return original && (
        item.data.GalenBulkUploads?.value !== original.data.GalenBulkUploads?.value ||
        item.data.GalenConfAccess?.value !== original.data.GalenConfAccess?.value
      );
    });
    
    console.log(originalData, 'Changed data:', changedData);
    
    if (changedData.length === 0) {
      alert('No changes to save');
      return;
    }

    try {
      // Update identity parameters (GalenBulkUploads, GalenConfAccess)
      const updatePromises = changedData.map(async (item) => {
        const payload = {
          "deviceDataModelId": "d36a4373-fbdc-44a3-8c96-4bb920041e40-id",
          "devicePropertySetId": "fdab73ae-28df-45f5-92c5-b24460daf682",
          "deviceDataId": item.deviceDataId,
          "data": {
            GalenBulkUploads: item.data?.GalenBulkUploads?.value, 
            GalenConfAccess: item.data?.GalenConfAccess?.value, 
          }
        };

        const endPoint = `${API_BASE_URL}/data/devicedata`;
        return await fetchRequest("POST", endPoint, payload);
      });

      // Wait for all updates to complete
      const results = await Promise.all(updatePromises);
      console.log("All updates completed:", results);
      
      // Show success alert
      alert(`Successfully saved ${changedData.length} changed records!`);
      
      // Update original data after save
      setOriginalData(JSON.parse(JSON.stringify(featureData)));
      setHasChanges(false);
    } catch (error) {
      console.error('Error saving changes:', error);
      alert('Error saving changes. Please try again.');
    }
  };

  return (
    <div>
      <NewFiltersBox onApply={fetchData} />
      
      {featureData?.length > 0 && (
        <Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <Person />
            </CardIcon>
            <Box style={{ float: "right" }}>
              <Button color="danger" disabled={hasChanges} onClick={downloadCSVData} style={{ marginRight: '10px' }}>Download CSV</Button>
              <Button color="primary" disabled={!hasChanges} onClick={handleSave} className={classes.saveButton}>Save Changes</Button>
            </Box>
          </CardHeader>
          <CardBody>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="premium features table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{minWidth: 120}} align="center">
                       <Typography>User</Typography>
                     </TableCell>
                     <TableCell style={{minWidth: 150}} align="center">
                       <Typography>Friendly Name</Typography>
                     </TableCell>
                     <TableCell style={{minWidth: 200}} align="center">
                       <Typography>Dev ID</Typography>
                     </TableCell>
                     <TableCell style={{minWidth: 200}} align="center">
                       <Typography>Fwvers</Typography>
                     </TableCell>
                     <TableCell style={{minWidth: 140}} align="center">
                       <Box display="flex" alignItems="center" justifyContent="center">
                         <Checkbox
                           checked={headerStates.GalenBulkUploads}
                           onChange={(e) => handleHeaderCheckboxChange('GalenBulkUploads', e.target.checked)}
                           className={classes.headerCheckbox}
                         />
                         <Typography>GalenBulkUploads</Typography>
                       </Box>
                     </TableCell>
                     <TableCell style={{ minWidth: 140 }} align="center">
                       <Box display="flex" alignItems="center" justifyContent="center">
                         <Checkbox
                           checked={headerStates.GalenConfAccess}
                           onChange={(e) => handleHeaderCheckboxChange('GalenConfAccess', e.target.checked)}
                           className={classes.headerCheckbox}
                         />
                         <Typography>GalenConfAccess</Typography>
                       </Box>
                     </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {featureData.map((item, index) => (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                    >
                      <TableCell style={{minWidth: 120, textAlign: "center"}}>
                        {userInfo?.fullName || 'N/A'}
                      </TableCell>
                      <TableCell style={{ minWidth: 150, textAlign: "center", fontWeight: '500'}}>
                        {item?.data?.FriendlyName?.value || 'N/A'}
                      </TableCell>
                      <TableCell style={{ minWidth: 200, textAlign: "center", fontFamily: 'monospace'}}>
                        {item?.data?.Devid?.value || 'N/A'}
                      </TableCell>
                      <TableCell style={{ minWidth: 200, textAlign: "center", fontFamily: 'monospace'}}>
                        {item?.data?.Fwvers?.value || 'N/A'}
                      </TableCell>
                      <TableCell style={{minWidth: 140, textAlign: "center", }} className={classes.cellCheckbox}>
                        <Checkbox
                          checked={(item?.data?.GalenBulkUploads?.value === 'yes' || item?.data?.GalenBulkUploads?.value === 'Yes') || false}
                          onChange={(e) => handleCheckboxChange(index, 'GalenBulkUploads', e.target.checked)}
                          inputProps={{ "aria-label": "enable bulk uploads checkbox" }}
                        />
                      </TableCell>
                      <TableCell style={{minWidth: 140, textAlign: "center" }} className={classes.cellCheckbox}>
                        <Checkbox
                          checked={(item?.data?.GalenConfAccess?.value === 'yes' || item?.data?.GalenConfAccess?.value === 'Yes') || false}
                          onChange={(e) => handleCheckboxChange(index, 'GalenConfAccess', e.target.checked)}
                          inputProps={{ "aria-label": "enable conf access checkbox" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
      )}
      
      {featureData?.length === 0 && !isLoading && userInfo && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '18px',
          fontWeight: 'bold',
          marginTop: '20px',
          color: '#666'
        }}>
          <span>No premium features data found</span>
        </div>
      )}
      
      <Loader status={isLoading} />
    </div>
  );
};

export default DeviceManagement;